import useAxios from "../../hooks/useAxios";

const useFsrAdminService = () => {
  const axiosList = useAxios();
  const axiosSave = useAxios();
  const axiosDelete = useAxios();
  const axiosCourseList = useAxios();
  const axiosCourseSave = useAxios();
  const axiosCourseDelete = useAxios();
  const axiosAllFsr = useAxios();

  const getAllFsr = async (faculty) => {
    await axiosAllFsr.fetchData({
      url: `/fsr/all`,
      method: "GET",
      params: faculty ? { faculty } : undefined,
    });
  };

  const getTermDates = async () => {
    await axiosList.fetchData({
      url: `/academic-term-dates`,
      method: "GET",
    });
  };

  const createTermDates = async (term_label, start_date, end_date) => {
    return await axiosSave.fetchData({
      url: `/academic-term-dates`,
      method: "POST",
      data: { term_label, start_date, end_date },
    });
  };

  const updateTermDates = async (id, start_date, end_date) => {
    return await axiosSave.fetchData({
      url: `/academic-term-dates/${id}`,
      method: "PUT",
      data: { start_date, end_date },
    });
  };

  const deleteTermDates = async (id) => {
    return await axiosDelete.fetchData({
      url: `/academic-term-dates/${id}`,
      method: "DELETE",
    });
  };

  const getCourses = async () => {
    await axiosCourseList.fetchData({
      url: `/course`,
      method: "GET",
    });
  };

  const createCourse = async (course_number, course_title, fos) => {
    return await axiosCourseSave.fetchData({
      url: `/course`,
      method: "POST",
      data: { course_number, course_title, fos },
    });
  };

  const updateCourse = async (id, course_number, course_title, fos) => {
    return await axiosCourseSave.fetchData({
      url: `/course/${id}`,
      method: "PUT",
      data: { course_number, course_title, fos },
    });
  };

  const deleteCourse = async (id) => {
    return await axiosCourseDelete.fetchData({
      url: `/course/${id}`,
      method: "DELETE",
    });
  };

  return {
    getTermDates,
    listLoading: axiosList.loading,
    listResponse: axiosList.response,
    createTermDates,
    updateTermDates,
    saveLoading: axiosSave.loading,
    deleteTermDates,
    deleteLoading: axiosDelete.loading,

    getCourses,
    courseListLoading: axiosCourseList.loading,
    courseListResponse: axiosCourseList.response,
    createCourse,
    updateCourse,
    courseSaveLoading: axiosCourseSave.loading,
    deleteCourse,
    courseDeleteLoading: axiosCourseDelete.loading,

    getAllFsr,
    allFsrLoading: axiosAllFsr.loading,
    allFsrResponse: axiosAllFsr.response,
  };
};

export default useFsrAdminService;
